
import React, {useEffect, useState} from 'react';
import logo from '../assets/Images/wglogo.png'
import { Link } from 'react-router-dom';
import PrimaryButton from '../Co Components/PrimaryButton';
// import '../assets/scss/custom.scss';
import logofoot from '../assets/Images/logo-foot.png';
import axios from "axios";
import PopupMessage from "../Co Components/PopupMessage";
import PopupCloseMessage from "../Co Components/PopupCloseMessage";


const Footer = () => {
           const [showPopup, setShowPopup] = useState(false);
    const [success,setSucess]=useState(false);
    const [error,setError]=useState(false);

     useEffect(() => {
  setTimeout(() => {
    setShowPopup(false);
  }, 10000);
}, );

    const handleCloseClick = () => {
        setShowPopup(false);
    };
    const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    axios.post('/contactus/email/', data,).then((response) => {
     if (response.status === 200) {
         // console.log('successful');
         // console.log(response.data);
         setTimeout(() => {
        setSucess(true);
        event.target.reset();
        setShowPopup(true);
      }, 500);
         // Redirect to the home page after login
      }  // console.log('failed');
    }).catch((error) => {
        if (error.response.status === 400) {
      // Display error message for invalid data entry

            setError(true);
            setShowPopup(true);
        } else {
      // Display generic error message
            setError(true);
         setShowPopup(true);
        }});
  };
    return (
        <>

         {(showPopup && success) && (
                    <PopupMessage onClose={handleCloseClick} text={"Your message has been sent successfully!"} />
      )}
                {(showPopup && error) &&
                    <PopupCloseMessage onClose={handleCloseClick} text={"Invalid E-mail Address, Please try again with the right E-mail"} />
      }

        <footer >
            <div className='sub-headings'>
                <h3 className='allura title red'>let's work</h3>
                <h2 className='bebas text-black title'>together</h2>
            </div>
            <div className='footer-container'>
                <div className='container'>


                    <div className='row footer-section1'>
                        <div className='d-flex flex-wrap   justify-content-lg-around justify-content-center '>
                            <div className='p-1 order-2 order-lg-1 '>
                                <h3 className='foothead-3 pt-5'>Contact Us</h3>

                                <form className='contact-form ' onSubmit={handleSubmit}>
                                    <input name={'email'} className='footinput' placeholder='EMAIL ADDRESS' />
                                    <button  className='secondary arrow '>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="23" viewBox="0 0 31 23" fill="none">
                                            <path d="M2.48633 9.9375C1.6579 9.9375 0.986328 10.6091 0.986328 11.4375C0.986328 12.2659 1.6579 12.9375 2.48633 12.9375V9.9375ZM30.0552 12.4982C30.641 11.9124 30.641 10.9626 30.0552 10.3768L20.5093 0.830898C19.9235 0.245111 18.9737 0.245111 18.3879 0.830898C17.8022 1.41669 17.8022 2.36643 18.3879 2.95222L26.8732 11.4375L18.3879 19.9228C17.8022 20.5086 17.8022 21.4583 18.3879 22.0441C18.9737 22.6299 19.9235 22.6299 20.5093 22.0441L30.0552 12.4982ZM2.48633 12.9375H28.9945V9.9375H2.48633V12.9375Z" fill="black" />
                                        </svg>
                                    </button>
                                </form>
                            </div>
                            <div className=' pt-5 order-1 order-lg-2 d-md-flex justify-content-lg-around justify-sm-content-around '>
                                <div className='p-4  '>
                                    <h4 className='foothead-4 ml-0' >Discover</h4>
                                    <ul className=' footfields'>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'/services'}><li>Services</li></Link>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'/tech-partners'}>
                                        <li>Technology Partners</li>
                                        </Link>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'/resellers-partners'}>
                                        <li>Resellers Partners</li>
                                        </Link>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'/blog'}><li>Blogs</li></Link>
                                    </ul>
                                </div>
                                <div className='p-4  '>
                                    <h4 className='foothead-4' >Follow Us</h4>
                                    <ul className=' footfields'>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'https://www.linkedin.com/company/thewhiteguard/'}><li>Linkedin</li></Link>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'https://twitter.com/WHITEGUARDLTD'}><li>X</li></Link>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'https://join.skype.com/invite/I29MJiU2Vl3G'}><li>Skype</li></Link>
                                    </ul>
                                </div>
                                <div className='p-4  '>
                                    <h4 className='foothead-4' >Who We Are</h4>
                                    <ul className=' footfields'>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'/FAQs'}><li>FAQs</li></Link>
                                        <Link style={{transition:'all 0.2s ease'}} className={'text-decoration-none'} to={'/about'}><li>About Us</li></Link>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='d-flex  justify-content-lg-between align-items-center justify-content-center footlower flex-column flex-lg-row '>
                            <div className='order-2 order-lg-1 mb-5 '>
                                <p className='MouseCursor'><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-geo-alt-fill me-2" viewBox="0 0 20 20">
                                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                </svg>s 128, City Road, London, EC1V 2NX, UNITED KINGDOM</p>
                                <p className='MouseCursor'><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-envelope-fill me-2" viewBox="0 0 20 20">
                                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                                </svg>sales@whiteguard.co.uk</p>
                                <p className='MouseCursor'><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-telephone-fill me-2" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                </svg>+44 1227391144</p>
                            </div>
                            <div className='flex-row-center order-1 mb-5 order-lg-2'>
                                <div>
                                    <img src={logofoot} width={'50px'} />
                                </div>
                                <div className='foot-slogan'>
                                    <p>
                                        <i className='bolder'>Secure</i> your cyberspace,

                                    </p>
                                    <p>

                                        <i className='bolder'>Secure</i>  your digital life.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <center><p>©2022 THE WHITEGUARD, Ltd. <br />All Rights Reserved.</p></center>

        </footer>
    </>
    );

}

export default Footer;